import { useAuth } from "@/components/context/AuthContext"
import styles from "./tournament-filters.module.css"

export default function TournamentFilters({
  sortBy,
  searchQuery,
  status,
  onSortChange,
  onSearchChange,
  onStatusChange,
}) {

  const { user } = useAuth();

  return (
    <aside className={styles.filtersPanel}>
      <div className={styles.filterSection}>
        <h3 className={styles.filterTitle}>Search</h3>
        <input
          type="text"
          placeholder="Search tournaments..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className={styles.searchInput}
        />
      </div>

      <div className={styles.filterSection}>
        <h3 className={styles.filterTitle}>Sort By</h3>
        <select value={sortBy} onChange={(e) => onSortChange(e.target.value)} className={styles.selectInput}>
          <option value="-maxPlayers">Max Players</option>
          <option value="-prizePool">Prize Pool</option>
          <option value="-registrationPrice">Registration Price</option>
          <option value="-tournamentDate">Tournament Date</option>
        </select>
      </div>

      {user?.role==="admin" && (        
        <div className={styles.filterSection}>
          <h3 className={styles.filterTitle}>Status</h3>
          <select value={status} onChange={(e) => onStatusChange(e.target.value)} className={styles.selectInput}>
            <option value="">All</option>
            <option value="upcoming">Upcoming</option>
            <option value="registration_open">Registration Open</option>
            <option value="registration_closed">Registration Closed</option>
            <option value="ongoing">Ongoing</option>
            <option value="completed">Completed</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>
      )}
    </aside>
  )
}
